// extracted by mini-css-extract-plugin
module.exports = {"Container":"Profile_Container__2KO94","Row":"Profile_Row__1h66h","infoColor":"Profile_infoColor__1wcsv","NoBorder":"Profile_NoBorder__3GWJF","Btn":"Profile_Btn__3ygle"};